"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPrimaryLocationImage = void 0;
var getPrimaryLocationImage_1 = require("./getPrimaryLocationImage");
Object.defineProperty(exports, "getPrimaryLocationImage", { enumerable: true, get: function () { return getPrimaryLocationImage_1.getPrimaryLocationImage; } });
//# sourceMappingURL=index.js.map